import * as React from "react";
import ProductEditPopup from "../containers/products/ProductEditPopup";
import BaseProductListLayout from "./BaseProductListLayout";

export default function ({ productId }) {
  return BaseProductListLayout(<ProductEditPopup productId={productId} />);
}
